import React from 'react';
import placeholder from '../../images/placeholder.png';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { useStrapiContext } from '../context/StrapiContext';

const StrapiImage = ({ src, img, alt, isDecorative = false, ...props }) => {
  const { allStrapiFile } = useStrapiContext();
  
  // Debug logs
  //console.log('Looking for image:', src);
  //console.log('Available images:', allStrapiFile?.nodes);

  if (img) {
    return (
      <GatsbyImage 
        image={img} 
        alt={isDecorative ? "" : (alt || "")} 
        {...props} 
      />
    );
  }

  if (src) {
    // Extract filename from src path
    const filename = src.split('/').pop();
    
    // Find matching image node
    const imageNode = allStrapiFile?.nodes?.find(node => {
      //console.log('Comparing:', filename, 'with:', node.name);
      return node.name === filename || node.localFile?.base === filename;
    });

    //console.log('Found node:', imageNode);

    if (imageNode?.localFile?.childImageSharp?.gatsbyImageData) {
      const gatsbyImageData = getImage(imageNode.localFile.childImageSharp.gatsbyImageData);
      //console.log(imageNode.alternativeText)
      return (
        <GatsbyImage 
          image={gatsbyImageData}
          alt={isDecorative ? "" : (alt || imageNode.alternativeText || "img")}
          title={imageNode.caption || ''}
          {...props}
        />
      );
    }

    // Fallback to direct URL if Gatsby image is not available
    if (imageNode?.url) {
      return (
        <img 
          src={imageNode.url}
          alt={isDecorative ? "" : (alt || imageNode.alternativeText || "img")}
          title={imageNode.caption || ''}
          {...props}
        />
      );
    }
  }

  // Fallback to placeholder
  return (
    <img 
      src={placeholder} 
      alt={isDecorative ? "" : (alt || "Default placeholder")} 
      {...props} 
    />
  );
};

export default StrapiImage;
